@for (label of labels; track label; let i = $index) {
  <div
    class="menu-item"
    [class.selected]="selectedIndex == i"
    [ngStyle]="selectedIndex == i ? selectedStyle : undefined"
    (click)="clickItem(i)"
  >
    {{ label }}
  </div>
}
